<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>数据报表</span>
    </div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="推广渠道" prop="startDate">
        <el-select v-model.number="queryParams.platForm" filterable placeholder="请选择">
          <el-option
            v-for="item in channel"
            :key="item.value"
            filterable
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="国家" prop="startDate">
        <el-select v-model="queryParams.country" filterable placeholder="请选择">
          <el-option

            v-for="item in country"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <el-button style="margin-left: 10px;" :loading="loading" icon="el-icon-download" size="mini" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="日期"
        align="center"
        width="100"
      />
      <el-table-column
        prop="ad_price"
        label="投放花费"
        align="center"
      >
        <template scope="scope">${{ scope.row.ad_price }}</template>
      </el-table-column>
      <el-table-column
        prop="ad_install"
        label="广告安装"
        align="center"
      />
      <el-table-column
        prop="user_price"
        label="当前回收"
        align="center"
      >
        <template scope="scope">${{ scope.row.user_price }}</template>
      </el-table-column>
      <el-table-column
        prop="roi"
        label="当前ROI"
        align="center"
      >
        <template scope="scope">{{ scope.row.roi }}%</template>
      </el-table-column>
      <el-table-column
        prop="cac"
        label="注册成本"
        align="center"
      >
        <template scope="scope">${{ scope.row.cac }}</template>
      </el-table-column>
      <el-table-column
        prop="ltv"
        label="当前LTV"
        align="center"
      />
      <el-table-column
        prop="pay_user"
        label="付费人数"
        align="center"
      />
      <el-table-column
        prop="pay_rate"
        label="付费率"
        align="center"
      >
        <template scope="scope">{{ scope.row.pay_rate }}%</template>
      </el-table-column>
      <el-table-column
        prop="arppu"
        label="ARPPU"
        align="center"
      >
        <template scope="scope">${{ scope.row.arppu }}</template>
      </el-table-column>
      <el-table-column
        prop="ad_other_data.roi"
        label="首日ROI"
        align="center"
      > <template scope="scope">{{ scope.row.ad_other_data.roi }}%</template>
      </el-table-column>
      <el-table-column
        prop="ad_other_data.roi7"
        label="7日ROI"
        align="center"
      ><template scope="scope">{{ scope.row.ad_other_data.roi7 }}%</template>
      </el-table-column>
      <el-table-column
        prop="ad_other_data.roi30"
        label="30日ROI"
        align="center"
      ><template scope="scope">{{ scope.row.ad_other_data.roi30 }}%</template>
      </el-table-column>
      <el-table-column
        prop="ad_other_data.roi60"
        label="30日ROI"
        align="center"
      ><template scope="scope">{{ scope.row.ad_other_data.roi60 }}%</template>
      </el-table-column>
      <el-table-column
        prop="ad_other_data.roi90"
        label="30日ROI"
        align="center"
      ><template scope="scope">{{ scope.row.ad_other_data.roi90 }}%</template>
      </el-table-column>
      <el-table-column
        prop="ad_other_data.ltv"
        label="首日LTV"
        align="center"
      />
      <el-table-column
        prop="ad_other_data.ltv7"
        label="7日LTV"
        align="center"
      />
      <el-table-column
        prop="ad_other_data.ltv30"
        label="30日LTV"
        align="center"
      />
      <el-table-column
        prop="ad_other_data.ltv60"
        label="60日LTV"
        align="center"
      />
      <el-table-column
        prop="ad_other_data.ltv90"
        label="90日LTV"
        align="center"
      />
    </el-table>
  </el-card>
</template>

<script>
import { getAd } from '@/api/statistics/user_remain'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'

export default {
  name: 'DataStatBasic',
  data() {
    return {
      loading: false,
      country: [],
      channel: [
        { label: '全部', value: 0 },
        { label: 'FB推广渠道', value: 1 },
        { label: '谷歌推广渠道', value: 2 },
        { label: 'Apple Ads', value: 3 }
      ],
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '0',
        platForm: 0,
        type: 0
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    // this.queryParams.startDate = '2024-12-01'
    // this.queryParams.endDate = '2024-12-15'
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.type = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getAd(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.data
          const country = res.data.country
          this.country = [{ value: '0', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: country[i], label: country[i] })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.loading = true
      this.queryParams.type = 1
      getAd(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
